import { InputBase } from '@mui/material'
import React from 'react'

const InputBox = ({sx, autoFocus, type, onCopy, onPaste, onKeyDown, onClick, readOnly, disabled,disabledcolor, placeholder, endAdornment, name, onChange, onblur, inputRef, id,Default,register,value, onKeyPress,min,onInput,inputProps}) => {   
  return (
    <InputBase fullWidth onPaste={onPaste} autoFocus={autoFocus} onKeyDown ={onKeyDown} onCopy={onCopy} disabled={disabled} type={type} value={value} defaultValue={Default} sx={{...sx, "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor:disabledcolor
    }, mt:0.5, height:'50px'}} id={id} onChange={onChange} onClick ={onClick} readOnly={readOnly} onBlur={onblur} placeholder={placeholder} endAdornment={endAdornment} name={name} onKeyPress={onKeyPress} inputRef={inputRef} onInput={onInput} inputProps={inputProps}></InputBase>
  )
}

export default InputBox